import React, { useState } from 'react';
import CMSArticle from 'src/shared/components/cms-article/CMSArticle';
import Modal from 'src/shared/components/modal/Modal';

type ImpactsAndDependenciesInfoBlockProps = {
    title: string;
    icon: React.ComponentType<{ className?: string }>;
    slug: string;
    description?: string;
};

const ImpactsAndDependenciesInfoBlock = ({ title, icon: Icon, slug, description }: ImpactsAndDependenciesInfoBlockProps) => {
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <div className='bg-white rounded-card shadow-xs p-5 flex flex-col gap-2.5'>
            <div className='flex items-center gap-2'>
                <Icon className='w-5 h-5 text-primary' />
                <h4 className='text-primary text-xl font-normal tracking-tight leading-snug'>{title}</h4>
                <button className='border border-border rounded-lg px-2 py-0.5 text-xs text-foreground' onClick={() => setModalOpen(true)}>
                    Learn more
                </button>
            </div>
            {description && <p className='text-sm font-normal text-muted-foreground'>{description}</p>}
            {modalOpen && (
                <Modal
                    onClose={() => setModalOpen(false)}
                    dismissOnClickOutside
                    classNames={{ body: 'max-h-[90vh] w-[80vw] max-w-[800px]' }}
                >
                    <CMSArticle slug={slug} shouldShowTitle />
                </Modal>
            )}
        </div>
    );
};

export default ImpactsAndDependenciesInfoBlock;
